import Model from 'core/model/Model';
import { fromNow } from 'core/util/dateUtils';

class RunbookModel extends Model {
  get urlRoot() {
    return '/api/ui/runbook';
  }

  get timeAgo() {
    return fromNow(this.get('cdate'));
  }

  get revisionId() {
    return Number(this.get('revision_id'));
  }

  getMappingsByType(resourceType) {
    const mappings = this.get('mappings');
    if (!mappings || typeof resourceType !== 'string' || !resourceType.trim()) {
      return [];
    }
    return mappings.filter((mapping) => mapping.resource_type === resourceType);
  }

  getMappingResourceTypes() {
    const mappings = this.get('mappings');
    if (!mappings) {
      return [];
    }
    const types = mappings.map((mapping) => mapping.resource_type);
    return [...new Set(types)].filter(Boolean);
  }

  hasMappingsOfType(resourceType) {
    return this.getMappingsByType(resourceType).length > 0;
  }

  get revisionAuthor() {
    const user = this.get('user');
    return user?.user_full_name || '';
  }

  toString() {
    const name = this.get('name');
    const description = this.get('description') || '';
    const instructions = this.get('display_md') || '';

    return `Name: ${name}\n\nDescription: ${description}\n\n${instructions}`;
  }
}

export default RunbookModel;
